<template>
    <div>
        <div
            class="modal-holder"
            v-if="authStore.showPersonSearch"
            @click="authStore.showPersonSearch = false"
        >
            <form
                @submit.prevent="findLeads()"
                class="modal-card modal-card-search-box"
                @click.stop=""
            >
                <div class="modal-card-header">
                    <h3>{{ $t("clp.SearchMember") }}</h3>
                </div>

                <div class="modal-content scroll-bar">
                    <div class="input-holder">
                        <label> {{ $t("clp.Name") }}</label>
                        <input type="text" v-model="search.name" />
                    </div>

                    <div class="input-holder">
                        <label> {{ $t("clp.MemberNumber") }}</label>
                        <input type="text" v-model="search.personKey" />
                    </div>

                    <div class="input-holder">
                        <label> {{ $t("clp.Phonenumber") }}</label>
                        <input type="text" v-model="search.phone" />
                    </div>

                    <div class="search-results scroll-bar">
                        <div v-if="findLeadIsLoading">
                            <div class="lds-ellipsis lds-ellipsis-blue">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>

                        <div
                            v-for="person in searchResults"
                            @click="
                                showFindedPersonCard(person.personId.externalId)
                            "
                        >
                            <h4>
                                {{ person.firstName }} {{ person.lastName }}
                            </h4>
                            <div>
                                {{ person.personId.center }}p{{
                                    person.personId.id
                                }}
                            </div>
                        </div>

                        <div v-if="searchResultEmpty">
                            {{ $t("clp.PersonsNotFound") }}
                        </div>
                    </div>
                </div>

                <div class="modal-buttons">
                    <div class="buttons button-holder-right">
                        <button
                            type="button"
                            @click="authStore.showPersonSearch = false"
                            class="button button-transparent"
                        >
                            {{ $t("clp.Close") }}
                        </button>

                        <button
                            type="submit"
                            :class="findLeadIsLoading ? 'button-disabled' : ''"
                            :disabled="findLeadIsLoading"
                            class="button"
                        >
                            {{ $t("clp.Search") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div
        class="modal-holder"
        tabindex="0"
        v-show="currentPerson.data !== undefined"
        @keydown.esc="currentPerson = {}"
        @click="currentPerson = {}"
    >
        <div
            class="person-card"
            @click.stop=""
            :class="[
                showPersonCard && showPersonCard !== false ? 'show' : '',
                showSuccess ? 'show-success' : '',
            ]"
        >
            <div class="person-card-header">
                <div
                    class="person-card-image"
                    :class="
                        currentPerson?.data?.clp_data?.contactedToday !== false
                            ? 'success'
                            : ''
                    "
                ></div>

                <div class="person-card-headline">
                    <h1>
                        {{ currentPerson?.data?.person?.person?.firstName }}
                        {{ currentPerson?.data?.person?.person?.lastName }}
                    </h1>
                    <h2>
                        {{ $t("clp.Leads") }}:
                        {{
                            getTranslation(
                                "categories",
                                currentPerson?.data?.clp_data?.currentCategory
                            )
                        }}
                    </h2>
                </div>
                <div class="modal-card-header-right">
                    <div
                        class="board-info-button"
                        v-if="this.personCardInfoTexts.sellMembership !== ''"
                    >
                        <i
                            class="material-icons-outlined icon-rock pointer icon-info"
                            @mouseover="
                                showInfo(
                                    {
                                        name: $t('clp.SellMembership'),
                                        info: this.personCardInfoTexts
                                            .sellMembership,
                                    },
                                    $event
                                )
                            "
                            @mouseout="showInfo(false, $event)"
                            >info</i
                        >
                    </div>
                    <a
                        :href="buildSalesUrl()"
                        class="button-text sell-membership"
                    >
                        {{ $t("clp.SellMembership") }}
                    </a>
                    <i class="material-icons-outlined color-blue pointer"
                        >open_in_new</i
                    >
                </div>
            </div>

            <div class="modal-content scroll-bar">
                <div class="person-card-content">
                    <div class="person-card-content-left">
                        <div class="list">
                            <div class="list-content">
                                <div class="list-row">
                                    <div>{{ $t("clp.Type") }}</div>
                                    <div>
                                        <div class="board-info-button">
                                            <i
                                                class="material-icons-outlined icon-rock pointer"
                                                @mouseover="
                                                    showInfo(
                                                        getTypeInfoText(
                                                            currentPerson?.data
                                                                ?.clp_data?.type
                                                        ),
                                                        $event
                                                    )
                                                "
                                                @mouseout="
                                                    showInfo(false, $event)
                                                "
                                                >info</i
                                            >
                                        </div>
                                        <span class="h4 ml-4 mb-0">{{
                                            getTranslation(
                                                "types",
                                                currentPerson?.data?.clp_data
                                                    ?.type
                                            )
                                        }}</span>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Date") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.clp_data
                                                ?.typeDate
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="person-card-content-right">
                        <div class="list">
                            <div class="list-content">
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.ContactStatus") }}
                                    </div>
                                    <div
                                        class="bold color-green"
                                        v-if="
                                            currentPerson?.data?.clp_data
                                                ?.contactedToday !==
                                                undefined &&
                                            currentPerson?.data?.clp_data
                                                ?.contactedToday !== false
                                        "
                                    >
                                        {{ $t("clp.ContactedToday") }}
                                    </div>
                                    <div
                                        class="bold color-red"
                                        v-if="
                                            currentPerson?.data?.clp_data
                                                ?.contactedToday === false
                                        "
                                    >
                                        {{ $t("clp.NotContactedToday") }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.SMSSended") }}</div>
                                    <div class="color-green">
                                        {{
                                            currentPerson?.data?.clp_data
                                                ?.sms_sended
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.LastContactOnType") }}
                                    </div>
                                    <div>
                                        {{
                                            currentPerson?.data?.clp_data
                                                ?.numberOfContactsOnCurrentCategory
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="person-card-content">
                    <div class="person-card-content-left">
                        <div class="list">
                            <div class="list-header">
                                <h3>{{ $t("clp.Persondata") }}</h3>
                                <div
                                    class="board-info-button"
                                    v-if="
                                        this.personCardInfoTexts.personData !==
                                        ''
                                    "
                                >
                                    <i
                                        class="material-icons-outlined icon-rock pointer"
                                        @mouseover="
                                            showInfo(
                                                {
                                                    name: $t('clp.Persondata'),
                                                    info: this
                                                        .personCardInfoTexts
                                                        .personData,
                                                },
                                                $event
                                            )
                                        "
                                        @mouseout="showInfo(false, $event)"
                                        >info</i
                                    >
                                </div>
                            </div>
                            <div class="list-content">
                                <div class="list-row">
                                    <div>{{ $t("clp.PersonKey") }}</div>
                                    <div
                                        v-if="
                                            currentPerson?.data?.person?.person
                                                ?.personId?.center
                                        "
                                    >
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.personId?.center
                                        }}p{{
                                            currentPerson?.data?.person?.person
                                                ?.personId?.id
                                        }}
                                    </div>
                                    <div v-else>-</div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Firstname") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.firstName
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Lastname") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.lastName
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.PhonenumberWork") }}
                                    </div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person
                                                ?.personCommunication
                                                ?.workPhoneNumber
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.PhonenumberHome") }}
                                    </div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person
                                                ?.personCommunication
                                                ?.homePhoneNumber
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Mobilenumber") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person
                                                ?.personCommunication
                                                ?.mobilePhoneNumber
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Persontype") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person
                                                ?.personTypeAndStatus
                                                ?.personType
                                        }}
                                    </div>
                                </div>

                                <div
                                    class="list-row"
                                    v-if="
                                        currentPerson?.data?.person
                                            ?.personTypeAndStatus
                                            ?.personType === 'CORPORATE'
                                    "
                                >
                                    <div>
                                        {{ $t("clp.CompanyAgreement") }}
                                    </div>
                                    <div
                                        v-if="
                                            currentPerson?.data?.person
                                                ?.companyRelation?.agreement
                                                ?.name
                                        "
                                    >
                                        {{
                                            currentPerson?.data?.person
                                                ?.companyRelation?.agreement
                                                ?.name
                                        }}
                                    </div>

                                    <div
                                        v-if="
                                            !currentPerson?.data?.person
                                                ?.companyRelation?.agreement
                                                ?.name
                                        "
                                    >
                                        Saknas
                                    </div>
                                </div>

                                <div class="list-row">
                                    <div>{{ $t("clp.Age") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.age
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.City") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.address?.country
                                        }}
                                        -
                                        {{
                                            currentPerson?.data?.person?.person
                                                ?.address?.zipName
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.DownloadedApp") }}
                                    </div>
                                    <div>
                                        {{
                                            currentPerson?.data?.person
                                                ?.extendedAttributes
                                                ?.TWIIKUSER == "true"
                                                ? $t("clp.Yes")
                                                : $t("clp.No")
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.QRCode") }}</div>
                                    <div
                                        v-if="
                                            currentPerson?.usedQRCode === true
                                        "
                                    >
                                        {{ $t("clp.Yes") }}
                                    </div>
                                    <div
                                        v-if="
                                            currentPerson?.usedQRCode === false
                                        "
                                    >
                                        {{ $t("clp.No") }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="list">
                            <div class="list-header">
                                <h3>{{ $t("clp.VisitHistory") }}</h3>
                                <div
                                    class="board-info-button"
                                    v-if="
                                        this.personCardInfoTexts
                                            .visitHistory !== ''
                                    "
                                >
                                    <i
                                        class="material-icons-outlined icon-rock pointer"
                                        @mouseover="
                                            showInfo(
                                                {
                                                    name: $t(
                                                        'clp.VisitHistory'
                                                    ),
                                                    info: this
                                                        .personCardInfoTexts
                                                        .visitHistory,
                                                },
                                                $event
                                            )
                                        "
                                        @mouseout="showInfo(false, $event)"
                                        >info</i
                                    >
                                </div>
                            </div>
                            <div class="list-content">
                                <div class="list">
                                    <div class="list-subheadline">
                                        {{ $t("clp.LastVisit") }}
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.LastCheckin") }}
                                        </div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastCheckin
                                            "
                                        >
                                            {{
                                                currentPerson.lastCheckin
                                                    ?.date !== undefined &&
                                                currentPerson.lastCheckin
                                                    ?.date !== ""
                                                    ? currentPerson.lastCheckin
                                                          .date +
                                                      " (" +
                                                      currentPerson.lastCheckin
                                                          .days_since_last_checkin +
                                                      " " +
                                                      $t("clp.days") +
                                                      ")"
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Center") }}</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastCheckin
                                            "
                                        >
                                            {{
                                                currentPerson.lastCheckin
                                                    ?.center_name !== undefined
                                                    ? currentPerson.lastCheckin
                                                          .center_name
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list">
                                    <div class="list-subheadline">
                                        {{ $t("clp.LastGTPass") }}
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Date") }}</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.class?.date !== undefined
                                                    ? currentPerson
                                                          .lastParticipations
                                                          .class.date
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Pass") }}:</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.class?.activity !==
                                                undefined
                                                    ? currentPerson
                                                          .lastParticipations
                                                          .class.activity
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Center") }}:</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.class?.center_name !==
                                                undefined
                                                    ? currentPerson
                                                          .lastParticipations
                                                          .class.center_name
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="list-subheadline">
                                    {{ $t("clp.LastPTPass") }}
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Date") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div
                                        v-else-if="
                                            currentPerson.lastParticipations
                                        "
                                    >
                                        {{
                                            currentPerson.lastParticipations?.pt
                                                ?.date !== undefined
                                                ? currentPerson
                                                      .lastParticipations.pt
                                                      .date
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Pass") }}:</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div
                                        v-else-if="
                                            currentPerson.lastParticipations
                                        "
                                    >
                                        {{
                                            currentPerson.lastParticipations?.pt
                                                ?.activity !== undefined
                                                ? currentPerson
                                                      .lastParticipations.pt
                                                      .activity
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Center") }}:</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div
                                        v-else-if="
                                            currentPerson.lastParticipations
                                        "
                                    >
                                        {{
                                            currentPerson.lastParticipations?.pt
                                                ?.center_name !== undefined
                                                ? currentPerson
                                                      .lastParticipations.pt
                                                      .center_name
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="list">
                            <div class="list-header">
                                <h3>{{ $t("clp.JournalAndNotes") }}</h3>
                                <div
                                    class="button-text"
                                    @click="showJournalNotes = true"
                                >
                                    {{ $t("clp.ShowMore") }}
                                </div>
                            </div>
                            <div class="journal-holder">
                                <div
                                    class="journal-note-item"
                                    v-for="(
                                        journalNote, index
                                    ) in currentPerson?.journalNotes"
                                    v-show="index === 0"
                                >
                                    <div
                                        class="journal-date"
                                        v-show="index === 0"
                                    >
                                        {{ journalNote.creationDate }} -
                                        {{ journalNote.creationTime }}
                                    </div>
                                    <div
                                        class="journal-note"
                                        v-show="index === 0"
                                    >
                                        {{
                                            formatJournalDate(journalNote?.text)
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="person-card-content-right">
                        <!-- Kontaktlogg -->
                        <div class="list">
                            <div class="list-header">
                                <h3>{{ $t("clp.ContactLog") }}</h3>
                                <div
                                    class="button-text"
                                    @click="showLogs = true"
                                >
                                    {{ $t("clp.ShowMore") }}
                                </div>
                            </div>
                            <div class="list-content">
                                <div class="list-row">
                                    <div>{{ $t("clp.Date") }}</div>
                                    <div>
                                        {{ currentPerson?.data?.logs[0]?.date }}
                                        {{
                                            getDatePrefix(
                                                currentPerson?.data?.logs[0]
                                                    ?.daysSinceLog
                                            )
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Time") }}</div>
                                    <div>
                                        {{ currentPerson?.data?.logs[0]?.time }}
                                    </div>
                                </div>
                                <div
                                    class="list-row"
                                    v-if="
                                        currentPerson?.data?.logs[0]
                                            ?.outcome !== ''
                                    "
                                >
                                    <div>{{ $t("clp.Outcome") }}</div>
                                    <div class="bold">
                                        {{
                                            getTranslation(
                                                "actions_categories",
                                                currentPerson?.data?.logs[0]
                                                    ?.outcome_id
                                            )
                                        }}
                                        <span
                                            v-if="
                                                currentPerson?.data?.logs[0]
                                                    ?.outcome
                                            "
                                            ><i
                                                class="outcome-arrow material-icons arrow"
                                                >east</i
                                            >
                                        </span>
                                        {{
                                            getTranslation(
                                                "actions",
                                                currentPerson?.data?.logs[0]
                                                    ?.action_id
                                            )
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Comment") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.logs[0]
                                                ?.comment
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Type") }}</div>
                                    <div>
                                        {{
                                            getTranslation(
                                                "types",
                                                currentPerson?.data?.logs[0]
                                                    ?.type
                                            )
                                        }}
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.User") }}</div>
                                    <div>
                                        {{
                                            currentPerson?.data?.logs[0]
                                                ?.handled_by
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Senaste köp -->
                        <div class="list">
                            <div class="list-header">
                                <h3>{{ $t("clp.LastPurchase") }}</h3>
                                <div
                                    class="board-info-button"
                                    v-if="
                                        this.personCardInfoTexts
                                            .lastPurchase !== ''
                                    "
                                >
                                    <i
                                        class="material-icons-outlined icon-rock pointer"
                                        @mouseover="
                                            showInfo(
                                                {
                                                    name: $t(
                                                        'clp.LastPurchase'
                                                    ),
                                                    info: this
                                                        .personCardInfoTexts
                                                        .lastPurchase,
                                                },
                                                $event
                                            )
                                        "
                                        @mouseout="showInfo(false, $event)"
                                        >info</i
                                    >
                                </div>
                            </div>
                            <div class="list">
                                <div class="list-content">
                                    <div class="list-subheadline">
                                        {{ $t("clp.Membership") }}
                                    </div>
                                    <div class="list-row">
                                        <div>Status</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.state ??
                                                "-"
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.Membership") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.product
                                                    ?.name ?? "-"
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.MembershipType") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.product
                                                    ?.type ?? "- "
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.BindingTime") }}
                                        </div>
                                        <div>
                                            <span
                                                v-if="
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.bindingEndDate
                                                "
                                            ></span>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]
                                                    ?.bindingEndDate ?? "-"
                                            }}
                                        </div>
                                    </div>

                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.Enddate") }}
                                        </div>
                                        <div>
                                            <span
                                                v-if="
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.endDate
                                                "
                                            ></span>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]
                                                    ?.endDate ?? "-"
                                            }}
                                        </div>
                                    </div>

                                    <div class="list-row">
                                        <div>{{ $t("clp.Gym") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]
                                                    ?.subscriptionId?.center ??
                                                "-"
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div
                                            v-if="
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.product
                                                    ?.type !== 'CASH'
                                            "
                                        >
                                            {{ $t("clp.MonthlyFee") }}
                                        </div>
                                        <div
                                            v-if="
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.product
                                                    ?.type === 'CASH'
                                            "
                                        >
                                            {{ $t("clp.Price") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.subscriptions[0]?.price ??
                                                "-"
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.PurchaseLocation") }}
                                        </div>
                                        <div>-</div>
                                    </div>
                                </div>
                            </div>

                            <div class="list">
                                <div class="list-subheadline">
                                    {{ $t("clp.Course") }}
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Type") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards?.courses[0]
                                                ?.clipcardTypeName !== undefined
                                                ? currentPerson.clipcards
                                                      ?.courses[0]
                                                      ?.clipcardTypeName
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Date") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards?.courses[0]
                                                ?.sales?.transactionTime !==
                                            undefined
                                                ? currentPerson.clipcards
                                                      ?.courses[0]?.sales
                                                      ?.transactionTime
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>
                                        {{ $t("clp.PurchaseLocation") }}
                                    </div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards?.courses[0]
                                                ?.sales?.placeOfPurchase !==
                                            undefined
                                                ? currentPerson.clipcards
                                                      ?.courses[0]?.sales
                                                      ?.placeOfPurchase
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="list-subheadline">
                                {{ $t("clp.Clipcard") }}
                            </div>
                            <div class="list-row">
                                <div>{{ $t("clp.Type") }}</div>
                                <div v-if="!personExistInExerp">-</div>
                                <div v-else-if="currentPerson.clipcards">
                                    {{
                                        currentPerson.clipcards?.clipcards[0]
                                            ?.clipcardTypeName !== undefined
                                            ? currentPerson.clipcards
                                                  ?.clipcards[0]
                                                  ?.clipcardTypeName
                                            : "-"
                                    }}
                                </div>
                                <div v-else>
                                    <div class="loading-spinner"></div>
                                </div>
                            </div>
                            <div class="list-row">
                                <div>{{ $t("clp.Date") }}</div>
                                <div v-if="!personExistInExerp">-</div>
                                <div v-else-if="currentPerson.clipcards">
                                    {{
                                        currentPerson.clipcards?.clipcards[0]
                                            ?.sales?.transactionTime !==
                                        undefined
                                            ? currentPerson.clipcards
                                                  ?.clipcards[0]?.sales
                                                  ?.transactionTime
                                            : "-"
                                    }}
                                </div>
                                <div v-else>
                                    <div class="loading-spinner"></div>
                                </div>
                            </div>
                            <div class="list-row">
                                <div>{{ $t("clp.PurchaseLocation") }}</div>
                                <div v-if="!personExistInExerp">-</div>
                                <div v-else-if="currentPerson.clipcards">
                                    {{
                                        currentPerson.clipcards?.clipcards[0]
                                            ?.sales?.placeOfPurchase !==
                                        undefined
                                            ? currentPerson.clipcards
                                                  ?.clipcards[0]?.sales
                                                  ?.placeOfPurchase
                                            : "-"
                                    }}
                                </div>
                                <div v-else>
                                    <div class="loading-spinner"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="person-card-footer">
                <div class="person-card-footer-buttons button-holder-right">
                    <div
                        v-if="
                            currentPerson?.data?.clp_data?.contactedToday ===
                            false
                        "
                        class="button"
                        @click="openShowChangeStatusModal()"
                    >
                        {{ $t("clp.CallOutcome") }}
                    </div>
                    <div
                        v-if="
                            currentPerson?.data?.clp_data?.contactedToday !==
                            false
                        "
                        class="button button-disabled"
                        @click="openShowChangeStatusModal()"
                    >
                        {{ $t("clp.CallOutcome") }}
                    </div>
                    <div class="button" @click="closeCurrentPerson()">
                        {{ $t("clp.Cancel") }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Journal and notes -->
    <div class="modal-holder" v-if="showJournalNotes">
        <div class="modal-info-card">
            <div class="person-card-header">
                <h2>{{ $t("clp.JournalAndNotes") }}</h2>
                <div class="modal-close" @click="showJournalNotes = false">
                    <img src="/assets/icon-close.svg" />
                </div>
            </div>
            <div class="modal-content">
                <div
                    class="journal-note-item"
                    v-for="journalNote in currentPerson?.journalNotes"
                >
                    <div class="journal-date">
                        {{ journalNote.creationDate }} -
                        {{ journalNote.creationTime }}
                    </div>
                    <div class="journal-note">
                        {{ formatJournalDate(journalNote?.text) }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Logbook -->
    <div class="modal-holder" v-if="showLogs">
        <div class="modal-info-card">
            <div class="person-card-header">
                <h2>{{ $t("clp.ContactLog") }}</h2>
                <div class="modal-close" @click="showLogs = false">
                    <img src="/assets/icon-close.svg" />
                </div>
            </div>
            <div class="modal-content">
                <div v-for="logItem in currentPerson?.data?.logs">
                    <div class="journal-note-item">
                        <div class="journal-date">
                            {{ logItem.date }} {{ logItem.time }}
                            {{ getDatePrefix(logItem.daysSinceLog) }}
                        </div>
                        <div class="journal-note">
                            <span v-if="logItem.outcome !== ''">
                                {{
                                    getTranslation(
                                        "actions_categories",
                                        logItem.outcome_id
                                    )
                                }}
                                <i class="log-arrow material-icons arrow"
                                    >east</i
                                >
                                {{
                                    getTranslation("actions", logItem.action_id)
                                }}
                                <br />
                            </span>
                            {{ $t("clp.Comment") }}: {{ logItem.comment }}<br />
                            {{ $t("clp.Type") }}:
                            {{ getTranslation("types", logItem.type) }}<br />
                            <span v-if="logItem.handled_by">
                                {{ $t("clp.User") }}:
                                {{ logItem.handled_by }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tooltip" :class="'placement_' + tooltipPlacement">
        <h3>{{ tooltipItem.name }}</h3>
        <p>{{ tooltipItem.info }}</p>
    </div>
</template>

<script>
import { useAuthStore } from "../stores/auth.js";
import { mapStores } from "pinia";
import axios from "axios";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    data() {
        return {
            showJournalNotes: false,
            showLogs: false,
            loading: false,
            search: {
                name: "",
                personKey: "",
                phone: "",
            },
            searchResults: [],
            findLeadIsLoading: false,
            searchResultEmpty: false,
            axiosController: {},
            currentPerson: {},
            showPersonCard: false,
            showSuccess: false,
            translations: {},
            personCardInfoTexts: {},
            personExistInExerp: false,
            tooltipPlacement: "top",
            tooltipX: "-1000px",
            tooltipY: "-1000px",
            tooltipDisplay: "flex",
            tooltipItem: {},
        };
    },
    methods: {
        buildSalesUrl() {
            const params = [];
            const person = this.currentPerson?.data?.person?.person;
            const communication = this.currentPerson?.data?.person?.personCommunication;

            if (person?.firstName) {
                params.push(`name=${encodeURIComponent(person.firstName)}`);
            }
            if (person?.lastName) {
                params.push(`lastname=${encodeURIComponent(person.lastName)}`);
            }
            if (communication?.mobilePhoneNumber) {
                params.push(`phone=${encodeURIComponent(communication.mobilePhoneNumber)}`);
            }
            if (communication?.email) {
                params.push(`email=${encodeURIComponent(communication.email)}`);
            }

            const queryString = params.join('&');
            const url = `/app/sales?${queryString}`;
            return url;
        },
        closeCurrentPerson() {
            // Abort all axios requests for person and close the modal
            if (this.axiosController.getPerson !== undefined) {
                this.axiosController.getPerson.abort();
            }

            if (this.axiosController.getLastParticipations !== undefined) {
                this.axiosController.getLastParticipations.abort();
            }

            if (this.axiosController.getLastCheckin !== undefined) {
                this.axiosController.getLastCheckin.abort();
            }

            if (this.axiosController.getClipcards !== undefined) {
                this.axiosController.getClipcards.abort();
            }

            if (this.axiosController.getJournalNotes !== undefined) {
                this.axiosController.getJournalNotes.abort();
            }

            /*
            if (this.axiosController.lockLead !== undefined) {
                this.axiosController.lockLead.abort();
            }
            */

            if (this.axiosController.getQRCheckin !== undefined) {
                this.axiosController.getQRCheckin.abort();
            }

            this.showChangeStatusModal = false;

            //this.unlockLead(this.currentPerson.data.clp_data.personkey);

            this.currentPerson = {};
            this.showPersonCard = false;
            let self = this;
        },
        getDatePrefix(days) {
            if (days === undefined) {
                return "";
            }

            switch (days) {
                case 0:
                    return "(" + this.$t("clp.today") + ")";
                case 1:
                    return "(" + this.$t("clp.yesterday") + ")";
                default:
                    return "(" + days + " " + this.$t("clp.days") + ")";
            }
        },
        findLeads() {
            this.findLeadIsLoading = true;
            this.searchResults = [];
            this.searchResultEmpty = false;
            let self = this;

            axios
                .post(
                    self.authStore.api + "/clp/find-persons",
                    {
                        name: self.search.name,
                        personKey: self.search.personKey,
                        phone: self.search.phone,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.findLeadIsLoading = false;
                    self.searchResults = response.data;

                    if (self.searchResults.length === 0) {
                        self.searchResultEmpty = true;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        showFindedPersonCard(externalId) {
            let self = this;

            axios
                .get(self.authStore.api + "/clp/get-person/" + externalId, {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                })
                .then((response) => {
                    if (
                        response.data.person?.person?.personId?.center !==
                        undefined
                    ) {
                        let personKey =
                            response.data.person?.person?.personId?.center +
                            "p" +
                            response.data.person?.person?.personId?.id;
                        self.personExistInExerp = true;
                        this.getLastParticipations(personKey);
                        this.getLastCheckin(personKey);
                        this.getClipcards(personKey);
                        this.getJournalNotes(personKey);
                        this.getQRCheckin(
                            response.data.person?.person?.personId?.externalId
                        );
                    }

                    self.currentPerson.data = response.data;
                    self.showPersonCard = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTranslation(type, key) {
            if (this.translations?.[type]?.[key] !== undefined) {
                return this.translations?.[type]?.[key];
            }
            return key;
        },
        getLastParticipations(id) {
            this.controller = new AbortController();
            this.axiosController.getLastParticipations = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/lastParticipations",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getLastParticipations
                            .signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.lastParticipations = response.data;
                })
                .catch((error) => {});
        },
        getLastCheckin(id) {
            this.axiosController.getLastCheckin = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/lastCheckin",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getLastCheckin.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.lastCheckin = response.data;
                })
                .catch((error) => {});
        },
        getClipcards(id) {
            this.axiosController.getClipcards = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api + "/clp/lead/" + id + "/info/clipcards",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getClipcards.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.clipcards = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getJournalNotes(id) {
            this.axiosController.getJournalNotes = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/journalNotes",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getJournalNotes.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.journalNotes = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getQRCheckin(externalId) {
            console.log("getQRCheckin");
            this.axiosController.getQRCheckin = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        externalId +
                        "/info/QRCodeCheckin",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getJournalNotes.signal,
                    }
                )
                .then((response) => {
                    if (response.data.used !== undefined) {
                        self.currentPerson.usedQRCode = response.data.used;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatJournalDate(note) {
            if (note === null || note === undefined) {
                return "";
            }

            return note.replace(
                /[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{2}:[0-9]{2}:[0-9]{2}\s-\s/g,
                ""
            );
        },
        showInfo(boardItem, event) {
            var rect = event.target.getBoundingClientRect();
            this.tooltipItem = boardItem;

            console.log(boardItem);

            if (boardItem) {
                let that = this;

                setTimeout(function () {
                    let heightOfTooltip = document
                        .querySelector(".tooltip")
                        .getBoundingClientRect();
                    that.tooltipDisplay = "flex";
                    that.tooltipX = rect.x - 115 + "px";

                    if (rect.y > heightOfTooltip.height) {
                        that.tooltipPlacement = "top";
                        that.tooltipY =
                            rect.y - heightOfTooltip.height - 26 + "px";
                    } else {
                        that.tooltipPlacement = "bottom";
                        that.tooltipY = rect.y + 46 + "px";
                    }
                }, 1);
            } else {
                this.tooltipX = "-1000px";
                this.tooltipY = "-1110px";
                this.tooltipDisplay = "flex";
            }
        },
        getTypeInfoText(type) {
            // Find the type in the types object
            let typeObject = this.types.find((element) => {
                return element.name === type;
            });

            return {
                name: typeObject.name,
                info: typeObject.info,
            };
        },
    },
};
</script>
<style>
.tooltip {
    display: v-bind("tooltipDisplay");
    top: v-bind("tooltipY");
    left: v-bind("tooltipX");
}
</style>
